module.exports = __webpack_public_path__ + "resources/default-skin.b257fa9c5ac8c515.svg";


//////////////////
// WEBPACK FOOTER
// ../node_modules/photoswipe/dist/default-skin/default-skin.svg
// module id = 645
// module chunks = 0 1 2 3